/**
 * Coming back to a thread that could not be read (#43, Codex review pass 4): a page
 * opened offline from the cached shell asks `/state`, the request fails, and the
 * conversation — messages, board, a paused questionnaire — is simply not there. Such a
 * read raises the curtain whenever it settles, and when the curtain lifts over it the
 * page reloads once the active turn and any queued input have finished.
 */

import { ApiError } from '../transport/api';

/** Did the guide never answer? A 4xx is an answer (404 — a thread with nothing in it yet). */
export function restoreUnreached(error: unknown): boolean {
  return !(error instanceof ApiError && error.status >= 400 && error.status < 500);
}

/** A recovery request stays pending while a turn or queued input still needs this page. */
export function retryRestore(pending: boolean, offline: boolean, unreached: boolean, status: string, queued: boolean): boolean {
  return pending && !offline && unreached && status === 'idle' && !queued;
}
